import React from "react";
import SavingsCounter from "../components/dashboard/SavingsCounter";
import RecurringSavings from "../components/dashboard/RecurringSavings";
import OneTimeSavings from "../components/dashboard/OneTimeSavings";
import { useSavings } from "../context/SavingsContext";

const Dashboard: React.FC = () => {
  const { loading, error } = useSavings();

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="text-2xl">Loading savings data...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-red-800 text-white p-6 rounded-lg">
        <h2 className="text-xl font-bold mb-2">Error</h2>
        <p>{error}</p>
      </div>
    );
  }

  return (
    <div>
      <div className="mb-8">
        <h1 className="text-3xl font-bold mb-4">DOWCE Dashboard</h1>
        <p className="text-gray-300">
          Tracking savings and operational efficiencies at West Coast Drywall &
          Paint.
        </p>
      </div>

      <SavingsCounter />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
        <RecurringSavings />
        <OneTimeSavings />
      </div>

      <div className="bg-gray-900 p-6 rounded-lg">
        <h2 className="text-xl font-bold mb-4">About DOWCE</h2>
        <p className="mb-4">
          The Department of West Coast Efficiency (DOWCE) tracks cost savings
          and operational improvements across West Coast Drywall & Paint. Our
          mission is to identify, implement, and document initiatives that
          reduce costs and improve efficiency.
        </p>
        <p>
          View the detailed breakdown of all savings on the{" "}
          <a href="/receipts" className="text-blue-400 hover:underline">
            Wall of Receipts
          </a>{" "}
          page.
        </p>
      </div>
    </div>
  );
};

export default Dashboard;
